// src/features/ui/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: { loadingCount: 0 },
  reducers: {},
  extraReducers: (b) => {
    b.addMatcher((a) => a.type.endsWith('/pending'), (s) => { s.loadingCount += 1; })
     .addMatcher(
       (a) => a.type.endsWith('/fulfilled') || a.type.endsWith('/rejected'),
       (s) => { s.loadingCount = Math.max(0, s.loadingCount - 1); }
     );
  },
});

export const selectIsLoading = (state) => state.ui.loadingCount > 0;
export default uiSlice.reducer;
